/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { SlicedData, SlicedDataQuery } from '@gh/core-data';
import { RowNode } from 'ag-grid-community';

export type GridViewportRowData<T> = { [index: number]: T };

export interface GridViewportControl {
  insertRow(index: number, data: any): RowNode;

  removeRow(index: number): void;

  setRowData(rowData: GridViewportRowData<any>): void;

  setRowCount(rowCount: number): void;

  getRowNode(id: string): RowNode;
}

export interface GridViewportRange {
  start: number;
  end: number;
}

export interface GridViewport<T> {
  connect(control: GridViewportControl): void;

  disconnect(): void;

  setVisibleRange(range: GridViewportRange): void;
}

export interface GridViewportState<T> {
  loading: boolean;
  rowData: GridViewportRowData<T>;
  rowCount: number;
  range: GridViewportRange;
}

export function getViewportRange(state: GridViewportState<any>): GridViewportRange {
  return state.range;
}

export function getViewportRowData<T>(state: GridViewportState<T>): GridViewportRowData<T> {
  return state.rowData;
}

export function slicedDataQueryFromRange(range: GridViewportRange): SlicedDataQuery {
  return { from: range.start, to: range.end };
}

export function viewportDataFromSlicedData<T>(slicedData: SlicedData<T>): GridViewportRowData<T> {
  const rowData: GridViewportRowData<T> = {};

  const { data, from } = slicedData;
  data.forEach((dataItem, i) => rowData[i + from] = dataItem);

  return rowData;
}
